module.exports = __webpack_public_path__ + "images/image_default_previous_scene.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image_default_previous_scene.svg
// module id = 1458
// module chunks = 0